import React from "react";
import { EstimateList } from "@/components/Estimates/List/EstimateList";

const EstimatesPage: React.FC = () => {
  return <EstimateList />;
};

export default EstimatesPage;
